import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=bb2e824a&"
import script from "./Budget.vue?vue&type=script&lang=ts&"
export * from "./Budget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports